import React from 'react';

import { EmptyData, ErrorMessage } from 'shared/ui';
import { getServerErrorText } from 'shared/lib';

import { CarModelForm } from '../form';
import { useGetCarBrandsQuery } from 'entities/car-brand';

type Props = Omit<React.ComponentProps<typeof CarModelForm>, 'carBrands'>;

export function ConnectedCarModelForm(props: Props) {
  const { data, isFetching, error } = useGetCarBrandsQuery();

  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (!data) {
    return <EmptyData />;
  }

  return <CarModelForm {...props} carBrands={data.carBrandList} />;
}
